import React, { useState, useEffect, useContext } from 'react';
import { Redirect, useHistory } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import UserService from '../../services/UserService';
import UserContext from '../../contexts/UserContext';
import AuthService from '../../services/auth.services';
import FriendsService from '../../services/FriendService';
import ShareupInsideHeaderComponent from '../dashboard/ShareupInsideHeaderComponent';
import PostService from '../../services/PostService';
import fileStorage from '../../config/fileStorage';

function FollowingWidgetComponent() {
    const history = useHistory();

    const { user } = useContext(UserContext)

    const [followers, setFollowers] = useState([]);
	const [searchedFollowers, setSearchedFollowers] = useState([]);

    const getAllFollowers = async () => {
        const jwtUser = AuthService.getCurrentUser();
        if (!jwtUser || !jwtUser.username) return;
        try {
            const res = await UserService.getFollowers(jwtUser.username);
            setFollowers(Array.isArray(res?.data) ? res.data : []);
        } catch (error) {
            const status = error?.response?.status;
            if (status === 404) {
                setFollowers([]);
                return;
            }
            console.warn('FollowingWidgetComponent.getAllFollowers failed:', error);
            setFollowers([]);
        }
	}

    useEffect(() => {
        getAllFollowers()
    }, [])


    return (
        followers.length>0?
            <div className="widget sidebar-flwrs">
                <div className="row"><img src="../assets/images/Public-Account-300x300.png" style={{width: '13%'}}/>
                <p className="widget-title" style={{position:'absolute', left: '50px',}}>Who's following</p></div>
                <ul className="followers">
                    {
                        followers.slice(0, 4).map((follower_user) =>
                            <li key={follower_user.id} style={{display:'flex', width:'100%' ,padding:'10px',alignItems:'center'}}>
                                <figure style={{width:'20%'}}>
                                    <img src={ fileStorage.baseUrl+follower_user.profilePicturePath} alt="" />
                                </figure>
                                <div className="" style={{width:'55%',textAlign: 'left' ,paddingLeft:'10px',display:'flex',flexDirection:'column'}}>
                                    <h4>
                                        <a href={`/profile/${follower_user.email}`} title="">{`${follower_user.firstName} ${follower_user.lastName}`}</a>
                                    </h4>
                                    <p style={{fontSize:'12px',paddingTop:'5px'}}>{follower_user.numberOfFollowers} Followers</p>
                                </div>
                                <button title="" className="button" style={{width:'25%',margin:'10px',padding:'0 5px'}}>Unfollow</button>

                            </li>
                        )
                    }
                </ul>
            </div>
            :<></>
    );
}
export default FollowingWidgetComponent;